
export const AuthFetch = async (url, config = {
    method: 'GET'
}, typeResponse = 'json') => {
    console.log("ENTRO AL AUTH FETCH")

    const urlBase = process.env.REACT_APP_BEEDRONE_WEB_API;

    const decifrado = atob(localStorage.getItem('pm-session') || '')
    const datosSession = decifrado == '' ? {} : JSON.parse(decifrado);
    const token = 'Bearer' + ' ' + datosSession?.token;
    
    console.log("TOKEN DESDE EL AUTHFECH -> ", token)

    const response = await fetch(urlBase + url, {
        ...config,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
            'Origins' : ''
        }
    })
    if ([401].includes(Number(response.status))) {
        localStorage.clear();
        window.location.reload(false);
    }

    return await response[typeResponse || 'json']()
}


export const AuthFetchOauth = async (url, config = {
    method: 'GET'
}, typeResponse = 'json') => {
    const urlBase = process.env.REACT_APP_OAUTH_WEB_API;
    const decifrado = atob(localStorage.getItem('pm-session') || '')
    const datosSession = decifrado == '' ? {} : JSON.parse(decifrado);
    const token = 'Bearer' + ' ' + datosSession?.token;

    const response = await fetch(urlBase + url, {
        ...config,
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': tokenType + ' ' + token
            'Authorization': token
        }
    }).then(async (res) => {
            if (res.status === 401 ){
                localStorage.clear()
                window.location.href = '/login';
                // window.location.reload(false)
            } 
        return res[typeResponse]()
    });

    return response;
}

export const AuthFetchAtu = async (url, config = {
    method: 'GET'
}, typeResponse = 'json') => {
    const urlBase = process.env.REACT_APP_BEEDRONE_WEB_API_ATU;
    const decifrado = atob(localStorage.getItem('pm-session') || '')
    const datosSession = decifrado == '' ? {} : JSON.parse(decifrado);
    const token = 'Bearer' + ' ' + datosSession?.token;

    const response = await fetch(urlBase + url, {
        ...config,
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': tokenType + ' ' + token
            'Authorization': token
        }
    }).then(async (res) => {
            if (res.status === 401 ){
                localStorage.clear()
                window.location.href = '/login';
                // window.location.reload(false) 
            } 
        return res[typeResponse]()
    });

    return response;
}


export const AuthFetchTGUIO = async (url, config = {
    method: 'GET'
}, typeResponse = 'json') => {
    const urlBase = process.env.REACT_APP_TGUIO_WEB_API;
    const decifrado = atob(localStorage.getItem('pm-session') || '')
    const datosSession = decifrado == '' ? {} : JSON.parse(decifrado);
    const token = 'Bearer' + ' ' + datosSession?.token;

    const response = await fetch(urlBase + url, {
        ...config,
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': tokenType + ' ' + token
            'Authorization': token
        }
    }).then(async (res) => {
            if (res.status === 401 ){
                localStorage.clear()
                window.location.href = '/login';
                // window.location.reload(false) 
            } 
        return res[typeResponse]()
    });

    return response;
}

export const Fetch = async ({ url, method, headers, body, typeResponse }) => {
    try {
        const headersDefault = headers || {
            'Content-Type': 'application/json',
        };

        const response = await fetch(url, {
            method: method || 'GET',
            headers: { ...headersDefault },
            body: body || null
        });

        if ([401].includes(Number(response.status))) {
            localStorage.clear();
            window.location.reload(false);
        }

        return await response[typeResponse || 'json']();
    } catch (error) {
        console.error("Error fetching data: ", error);
        throw error;  // Puedes manejar el error como prefieras
    }
}
